import { RESET_BENEFICIARIO_STATE, UPDATE_BENEFICIARIO_STATE } from '../actions'

export default function (state = {}, action) {
  switch (action.type) {
    case UPDATE_BENEFICIARIO_STATE:
      return action.payload
    case RESET_BENEFICIARIO_STATE:
      return null
    default:
      return state
  }
}
